import { FC } from "react";
import {
  RaffleHeader,
  RaffleWheel,
  WheelRaffleItemStatus,
} from "entities/wheel-raffle";
import type { RaffleDetail } from "entities/wheel-raffle";
import { useAutoDraw } from "features/draw-wheel-raffle";
import { useWheelSpin } from "../../model/useWheelSpin";
import { ConditionsSection } from "./ConditionsSection";
import { ParticipantPanel } from "./ParticipantPanel";
import { PublicPeople } from "./PublicPeople";
import { RafflePeople } from "./RafflePeople";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  raffle: RaffleDetail;
  inviteCode: string | null;
}

// Справа люди: создателю — подробные списки v1 (призы, объёмы), остальным —
// публичные fid из detail. Розыгрыш у создателя запускается сам по окончании
// таймера. Условия — у всех внизу страницы.
export const RaffleLayout: FC<Props> = ({ raffle, inviteCode }) => {
  const isDrawn = raffle.status === WheelRaffleItemStatus.DRAWN;
  const { isSpinning, isRevealed, wheelState } = useWheelSpin(isDrawn);

  useAutoDraw({
    raffleId: raffle.id,
    endsAt: raffle.ends_at,
    enabled: raffle.is_creator && !isDrawn,
  });

  const renderActions = () => {
    if (isSpinning) {
      return <p className={styles.result}>Drawing the winners...</p>;
    }
    if (raffle.is_creator) return null;
    return (
      <ParticipantPanel
        raffle={raffle}
        isDrawn={isRevealed}
        inviteCode={inviteCode}
      />
    );
  };

  const renderSidePanel = () => {
    if (raffle.is_creator) {
      return (
        // key: после розыгрыша вкладки пересоздаются и открываются победители.
        <RafflePeople
          key={String(isRevealed)}
          raffleId={raffle.id}
          isDrawn={isRevealed}
          participantsCount={raffle.participants_count}
        />
      );
    }
    return (
      // key: после розыгрыша вкладки пересоздаются и открываются победители.
      <PublicPeople
        key={String(isRevealed)}
        lists={raffle.public_lists}
        isDrawn={isRevealed}
      />
    );
  };

  return (
    <>
      <div className={styles.columns}>
        <section className={styles.panel}>
          <RaffleHeader raffle={raffle} />
          <RaffleWheel state={wheelState} />
          {renderActions()}
        </section>
        <section className={styles.panel}>{renderSidePanel()}</section>
      </div>
      <section className={styles.panel}>
        <ConditionsSection raffle={raffle} />
      </section>
    </>
  );
};
